import { ConsoleLogger } from '@proposify/frontend-observability';
import type { AnalyticsRepository, TrackingPayload } from './AnalyticsRepository';

const postTracking = async (payload: TrackingPayload): Promise<void> => {
  ConsoleLogger.log('ApiAnalyticsRepository.postTracking ', JSON.stringify(payload, null, 2));

  const url = `${globalThis.env.VITE_DOCUMENT_ANALYTICS_API_ENDPOINT}/preview/events`;
  const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
  const sent = navigator.sendBeacon(url, blob);
  if (!sent) {
    ConsoleLogger.error('ApiAnalyticsRepository.postTracking: sendBeacon failed', payload);
  }
};

export const ApiAnalyticsRepository: AnalyticsRepository = {
  postTracking,
};
